import { get } from "svelte/store";
import { readableWritable } from "../shared/storeUtilities";
import { TestCaseCreator } from "../testCaseCreator";
export class TestCasesStore {
    constructor(testCaseDatas) {
        const testCases = new Array();
        for (var testCaseData of testCaseDatas) {
            const testCase = TestCaseCreator.createTestCase(testCaseData);
            testCase.logTextChangedEvent.add(this, this.onTestCaseChanged);
            testCase.erroredEvent.add(this, this.onTestCaseChanged);
            testCases.push(testCase);
        }
        ({ read: this._readableTestCases, write: this._writableTestCases } = readableWritable(testCases));
    }
    get readableTestCases() {
        return this._readableTestCases;
    }
    onTestCaseChanged() {
        this._writableTestCases.set(get(this._writableTestCases));
    }
}
